import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import $ from "jquery";
import ScrollToTop from "../ScrollToTop";

export default function Category() {
  const [blog, setBlog] = useState([]);
  const [isLoading, setLoading] = useState(true);

  $(document).ready(function () {
    $(".claimedRight").each(function (f) {
      var newstr = $(this).text().substring(0, 200);
      $(this).text(newstr + "...");
    });
  });

  useEffect(() => {
    axios
      .get("https://tamizhtechie-test.herokuapp.com/blog/")
      .then((res) => {
        setBlog(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const params = useParams();
  return (
    <div>
      <ScrollToTop />
      <div className="allnews">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div>
                {isLoading ? (
                  <div>
                    <div class="col-md-12">
                      <div class="row mt-4">
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                        <div class="col-12 mt-3">
                          <div class="ssc-square" style={{ height: 250 }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="row">
                      <div className="col-md-10">
                        {blog
                          .slice(0)
                          .reverse()
                          .map((values, i) => {
                            return (
                              <div key={i}>
                                {values.category === params.name ? (
                                  <Link
                                    to={{
                                      pathname: "/blog" + "/" + values.slug,
                                    }}
                                  >
                                    <div>
                                      <div className="row box-shadow mt-4">
                                        <div className="col-md-4 p-0">
                                          <img
                                            src={values.imageUrl}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </div>
                                        <div className="col-md-8">
                                          <h1>{values.title}</h1>
                                          <h6>
                                            {" "}
                                            <i
                                              className="fa fa-calendar pr-3"
                                              aria-hidden="true"
                                            ></i>
                                            {values.date}
                                          </h6>
                                          <h5>
                                            <div
                                              className="claimedRight"
                                              dangerouslySetInnerHTML={{
                                                __html: values.description,
                                              }}
                                            />
                                          </h5>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ) : null}
                              </div>
                            );
                          })}
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
